import { useCallback, useMemo, useRef } from 'react';
import { Option } from 'react-rainbow-components';
import { PicklistValue } from '@rainbow-modules/listview/lib/components/AuditLogs/types';
import ChevronDown from 'components/icons/chevronDown';
import Phone from 'components/icons/phone';
import formatIntlPhoneNumber from 'data/services/phone/formatter';
import {
    Container, StyledButtonIcon, StyledListTile, StyledPicklist,
} from './styled';
import { PhonePickerButtonProps } from './types';

const PhonePickerButton = ({
    value: valueInProps,
    onChange = () => {},
    phoneNumbers = [],
    ...rest
}: PhonePickerButtonProps) => {
    const picklistRef = useRef();

    const picklistValue = useMemo(() => {
        if (valueInProps) {
            const found = phoneNumbers.find(
                (phoneNumber) => phoneNumber.phoneNumber === valueInProps,
            );
            if (found) {
                return {
                    name: found.id,
                    label: formatIntlPhoneNumber(found.phoneNumber),
                    value: found.phoneNumber,
                };
            }
        }
        return undefined;
    }, [phoneNumbers, valueInProps]);

    const handleChange = useCallback(
        (newValue: PicklistValue) => onChange(newValue.value),
        [onChange],
    );
    return (
        <Container>
            <StyledButtonIcon
                icon={<ChevronDown />}
                size="small"
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                onClick={() => picklistRef.current?.click()}
            />
            <StyledPicklist
                {...rest}
                ref={picklistRef}
                value={picklistValue}
                onChange={handleChange}
            >
                {phoneNumbers.map((phoneNumber) => (
                    <Option
                        key={phoneNumber.id}
                        name={phoneNumber.id}
                        label={(
                            <StyledListTile
                                icon={<Phone />}
                                title={formatIntlPhoneNumber(phoneNumber.phoneNumber)}
                                subtitle={phoneNumber.phoneType}
                                isPrimary={phoneNumber.type === 'primary'}
                            />
                        )}
                        value={phoneNumber.phoneNumber}
                        searchableText={`${phoneNumber.phoneType} - ${phoneNumber.phoneNumber}`}
                    />
                ))}
            </StyledPicklist>
        </Container>
    );
};

export default PhonePickerButton;
